import { IAuditEntityData } from "src/app/core/interfaces/iaudit-entity-data";
import { EntityUtilsService } from "src/app/core/utils/entity-utils.service";
import { EntityName } from "../../enumerations/entity-name";
import { OperationType } from "../../enumerations/operation-type";
import { MiningEquipment } from "../save/mining-equipment";
import { MiningEquipmentNotesDisplay } from "./mining-equipment-notes-display";

export class MiningEquipmentDisplay extends MiningEquipment {
    plantId: number;
    plantName: string;
    areaId: number | null;
    areaName: string;
    ownerId: number | null;
    ownerName: string;
    unitName: string;
    miningEquipmentVendorName: string;
    miningEquipmentOwnerName: string;
    physAddressV1: string;
    physAddressV2: string;
    physCity: string;
    physState: string;
    physStateName: string;
    physPostalCode: string;
    physCountry: string;
    physCountryName: string;
    plantOffshore: boolean;
    offshoreBlockV1: string;
    offshoreWaterbodyName: string;
    offshoreFieldName: string;
    offshoreAreaName: string;
    hsUnit: string;
    hsProductDesc: string;
    lastUserEmailAddress: string;
    entryUserEmailAddress: string;
    previousUserEmailAddress: string;
    qcUserEmailAddress: string;
    releaseUserEmailAddress: string;
    amendmentUserEmailAddress: string;

    // MVTs
    miningEquipmentNotesDisplay: Array<MiningEquipmentNotesDisplay>;

    sellableNoteQcSelected: boolean;
    sellableNoteQcLastDate: string;
    sellableNoteQcLastUser: string;
    sellableNoteQcPrevDate: string;
    sellableNoteQcPrevUser: string;

    private constructor(entity?: any) {
        super(entity);
        this.plantId = entity?.plantId ?? null;
        this.plantName = entity?.plantName ?? '';
        this.areaId = entity?.areaId ?? null;
        this.areaName = entity?.areaName ?? '';
        this.ownerId = entity?.ownerId ?? null;
        this.ownerName = entity?.ownerName ?? '';
        this.unitName = entity?.unitName ?? '';
        this.miningEquipmentVendorName = entity?.miningEquipmentVendorName ?? '';
        this.miningEquipmentOwnerName = entity?.miningEquipmentOwnerName ?? '';
        this.physAddressV1 = entity?.physAddressV1 ?? '';
        this.physAddressV2 = entity?.physAddressV2 ?? '';
        this.physCity = entity?.physCity ?? '';
        this.physState = entity?.physState ?? '';
        this.physStateName = entity?.physStateName ?? '';
        this.physPostalCode = entity?.physPostalCode ?? '';
        this.physCountry = entity?.physCountry ?? '';
        this.physCountryName = entity?.physCountryName ?? '';
        this.plantOffshore = entity?.plantOffshore ?? false;
        this.offshoreBlockV1 = entity?.offshoreBlockV1 ?? '';
        this.offshoreWaterbodyName = entity?.offshoreWaterbodyName ?? '';
        this.offshoreFieldName = entity?.offshoreFieldName ?? '';
        this.offshoreAreaName = entity?.offshoreAreaName ?? '';
        this.hsUnit = entity?.hsUnit ?? '';
        this.hsProductDesc = entity?.hsProductDesc ?? '';
        this.lastUserEmailAddress = entity?.lastUserEmailAddress ?? '';
        this.entryUserEmailAddress = entity?.entryUserEmailAddress ?? '';
        this.previousUserEmailAddress = entity?.previousUserEmailAddress ?? '';
        this.qcUserEmailAddress = entity?.qcUserEmailAddress ?? '';
        this.releaseUserEmailAddress = entity?.releaseUserEmailAddress ?? '';
        this.amendmentUserEmailAddress = entity?.amendmentUserEmailAddress ?? '';

        this.miningEquipmentNotesDisplay = entity?.miningEquipmentNotesDisplay ?? [];

        this.sellableNoteQcSelected = entity?.sellableNoteQcSelected ?? false;
        this.sellableNoteQcLastDate = entity?.sellableNoteQcLastDate ?? null;
        this.sellableNoteQcLastUser = entity?.sellableNoteQcLastUser ?? null;
        this.sellableNoteQcPrevDate = entity?.sellableNoteQcPrevDate ?? null;
        this.sellableNoteQcPrevUser = entity?.sellableNoteQcPrevUser ?? null;

    }

    static BuildMiningEquipmentDisplay(entity: any): MiningEquipmentDisplay {
        entity = EntityUtilsService.convertUTCDates(entity);
        return new MiningEquipmentDisplay(entity);
    }

    static BuildNewMiningEquipment(response: any): MiningEquipmentDisplay {
        return new MiningEquipmentDisplay({
            miningEquipmentId: response[0].MINING_EQUIPMENT_ID,
            operation: OperationType.INSERT,
            intDataDepValState: OperationType.INSERT
        });
    }

    prepareSaveCollection() {
        this.miningEquipmentNotes = this.miningEquipmentNotesDisplay;
    }

    get auditEntityBean(): IAuditEntityData {
        return {
            lastUser: this.lastUser,
            entryUser: this.entryUser,
            prevUser: this.prevUser,
            qcUser: this.qcUser,
            lastDate: this.lastDate,
            entryDate: this.entryDate,
            prevDate: this.prevDate,
            qcDate: this.qcDate,
            releaseUser: this.releaseUser,
            releaseDate: this.releaseDate,
            amendmentUser: this.amendmentUser,
            amendmentDate: this.amendmentDate,
            lastUserEmailAddress: this.lastUserEmailAddress,
            entryUserEmailAddress: this.entryUserEmailAddress,
            previousUserEmailAddress: this.previousUserEmailAddress,
            qcUserEmailAddress: this.qcUserEmailAddress,
            releaseUserEmailAddress: this.releaseUserEmailAddress,
            amendmentUserEmailAddress: this.amendmentUserEmailAddress,
            lastUpdateStatus: '',
            entityName: EntityName.MEQUIPMENT,
            entityId: this.miningEquipmentId
        };
    }
}
